import { render } from "./modelToLogin.vue?vue&type=template&id=a5a01388&scoped=true"
import script from "./modelToLogin.vue?vue&type=script&lang=js"
export * from "./modelToLogin.vue?vue&type=script&lang=js"

import "./modelToLogin.vue?vue&type=style&index=0&id=a5a01388&scoped=true&lang=scss"

import exportComponent from "/www/wwwroot/manga-official-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5a01388"]])

export default __exports__